import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { GET_BOX_CLICK } from 'artkive/constants/tracker/mainNavigation'
import useSale from 'artkive/hooks/useSale'

import { ItemSeparator, SaleLink, Track, TrackItemLabel, Wrapper } from './SaleStripe.style'

const SaleStripe = ({ message }) => {
  const { priceLabel, boxCheckoutUrl, promoBar } = useSale()
  const movingItems = useMemo(() => Array.from({ length: 10 }, (_, index) => index), [])

  return (
    <Wrapper bgColor={promoBar.background}>
      <div style={{ overflow: 'hidden', whiteSpace: 'nowrap' }}>
        <Track>
          {movingItems.map((itemIndex) => (
            <TrackItemLabel variant='body2' key={itemIndex} component='span' textColor={promoBar.color}>
              {message}
              <ItemSeparator />
              <SaleLink
                href={boxCheckoutUrl}
                textColor={promoBar.color}
                trackerEvent={GET_BOX_CLICK}
                trackerOptions={{ section: 'home_sale_stripe' }}
                aria-label={`Go to ${priceLabel} Artkive box checkout`}
              >
                Order Now
              </SaleLink>
              →
            </TrackItemLabel>
          ))}
        </Track>
      </div>
    </Wrapper>
  )
}

SaleStripe.propTypes = {
  message: PropTypes.string.isRequired,
}

export default SaleStripe
